import * as FC from "@fluentui/react-components";
import * as IC from "@fluentui/react-icons";
import { useCommonStyles } from "../../../style_util";
import { SimpleGrid, useSimpleGrid } from "../../../components/simple_grid";
import {
    ModelLeafDef,
    listModelLeaf,
} from "../../../services/model_leaf_service";
import { useDrawer } from "../../../components/use_drawer";
import { bindInputValue, useInfo } from "../../../form_utils";
import { DeleteButton } from "../../../components/delete_button";
import { useContext } from "react";
import { Context } from "../../../context";
import { apiClient } from "../../../services/api";
import { describeWriteError } from "../../../services/write_errors";
import { ManuLeafDropdown } from "../../../services/manu_leaf_service";
import { getCurrentFieldId } from "../../../workspace";

const ModelLeafForm = ({ item, onChange }) => {
    const { user } = useContext(Context);
    const { info, setInfo, updateInfo } = useInfo();
    const v = bindInputValue(item, info, setInfo);
    // See manu_turbine.js: without ?tenantId= these writes can only ever return 400.
    const tenantId = user?.tenantId;

    const onDelete = async () => {
        try {
            await apiClient.deleteModelLeaf(item.id, tenantId);
            onChange();
        } catch (error) {
            console.error("Failed to delete leaf model:", error);
            alert("删除失败: " + describeWriteError(error));
        }
    };
    const onSave = async () => {
        try {
        if (item) {
            if (info.length) {
                info.length = parseFloat(info.length);
            }
            await apiClient.updateModelLeaf(item.id, info, tenantId);
            onChange();
        } else {
            const fieldId = getCurrentFieldId();
            // Extract numeric ID from SurrealDB record format (e.g., "field_item:2" -> 2)
            const numericFieldId = typeof fieldId === 'string' && fieldId.includes(':') 
                ? parseInt(fieldId.split(':')[1]) 
                : fieldId;
            
            // Extract numeric manufacturer ID
            const manuId = typeof info.manu === 'string' && info.manu.includes(':')
                ? parseInt(info.manu.split(':')[1])
                : info.manu;

            let _info = { 
                Seq: info.seq || '',
                Length: info.length ? parseFloat(info.length) : 0,
                Description: info.description || '',
                ManuId: manuId,
                FieldItemId: numericFieldId
            };
            console.log('Creating model_leaf with data:', _info);
            await apiClient.createModelLeaf(_info, tenantId);
            onChange();
        }
        } catch (error) {
            console.error("Failed to save leaf model:", error);
            alert("保存失败: " + describeWriteError(error));
        }
    };

    const commonStyles = useCommonStyles();
    return (
        <div className={commonStyles.form}>
            <FC.Input contentBefore={"编号"} {...v("seq")} />
            <FC.Label>选择厂商</FC.Label>
            <ManuLeafDropdown
                defaultValue={item?.manu?.name}
                onOptionSelect={(evt, data) => {
                    updateInfo({ manu: data.optionValue });
                }}
            />
            <FC.Input
                contentBefore={"长度(米)"}
                type="number"
                {...v("length")}
            />
            <FC.Label>备注</FC.Label>
            <FC.Textarea {...v("description")} />
            <FC.Divider />
            {item && <DeleteButton onClick={onDelete} />}
            <FC.Button onClick={onSave} disabled={!info} appearance="primary">
                {(item && "保存") || "创建"}
            </FC.Button>
        </div>
    );
};
export const ModelLeafManagement = () => {
    const { openDrawer, closeDrawer, drawer } = useDrawer();

    const { items, refresh, SearchInput } = useSimpleGrid({
        listItems: listModelLeaf,
        placeholder: "按厂商、长度搜索...",
    });

    const onFormChange = () => {
        refresh();
        closeDrawer();
    };

    const onNewModelLeaf = () => {
        openDrawer({
            header: "创建叶片型号",
            body: <ModelLeafForm item={null} onChange={onFormChange} />,
        });
    };
    const columns = [
        ModelLeafDef.createTableColumn("seq"),
        ModelLeafDef.createTableColumn("manu"),
        ModelLeafDef.createTableColumn("length"),
        ModelLeafDef.createTableColumn("description"),
        ModelLeafDef.createOpsColumn({
            renderCell: (item) => {
                const onClick = () => {
                    openDrawer({
                        header: "叶片型号详情",
                        body: (
                            <ModelLeafForm
                                item={item}
                                onChange={onFormChange}
                            />
                        ),
                    });
                };
                return (
                    <FC.TableCellLayout>
                        <FC.Button
                            appearance="subtle"
                            icon={<IC.MoreCircleFilled />}
                            onClick={onClick}
                        />
                    </FC.TableCellLayout>
                );
            },
        }),
    ];
    const commonStyles = useCommonStyles();
    return (
        <div className={commonStyles.root}>
            <div className={commonStyles.row}>
                <FC.Label>快速检索</FC.Label>
                <SearchInput />
                <FC.Button appearance="primary" onClick={onNewModelLeaf}>
                    创建叶片型号
                </FC.Button>
            </div>
            <SimpleGrid items={items} columns={columns} />
            {drawer}
        </div>
    );
};
